module.exports = __webpack_public_path__ + "8ec25c73c72ea2622ccc63e063e302ec.svg";